export const PROFESSIONAL_REFERENCE = 'professionalReference';
export const UNKNOWN_PROFESSIONAL_REFERENCE = 'unknownProfessionalReference';
export const PRACTICE_NUMBER = 'practiceNumber';
